import type { LinkProps } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';

import GridIcon from '../../assets/icons/grid.svg';
import ListIcon from '../../assets/icons/list.svg';
import { GameView } from '../../types/common';

import styles from './GridListViewToggle.scss';
import GridListViewToggleButton from './GridListViewToggleButton';

export interface Props {
  id: string;
  selected?: GameView;
  handleSelect?(selected: GameView): void;
  config?: {
    [GameView.Grid]: LinkProps;
    [GameView.List]: LinkProps;
  };
  classes?: {
    container?: string;
    button?: string;
    active?: string;
  };
}

const GridListViewToggle: React.FC<Props> = ({
  id,
  selected = GameView.Grid,
  handleSelect,
  config,
  classes
}) => {
  const [selectedOption, setSelectedOption] = useState(selected);

  const handleOptionSelect = (selectedItem: GameView) => {
    setSelectedOption(selectedItem);
    handleSelect?.(selectedItem);
  };

  return (
    <div data-testid={id} className={classNames(styles.container, classes?.container)}>
      <GridListViewToggleButton
        id={id}
        gameView={GameView.Grid}
        selected={selectedOption === GameView.Grid}
        handleSelect={handleOptionSelect}
        linkProps={config?.[GameView.Grid]}
        icon={<GridIcon />}
        classes={classes}
      />
      <GridListViewToggleButton
        id={id}
        gameView={GameView.List}
        selected={selectedOption === GameView.List}
        handleSelect={handleOptionSelect}
        linkProps={config?.[GameView.List]}
        icon={<ListIcon />}
        classes={classes}
      />
    </div>
  );
};
export default GridListViewToggle;
